if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends SideDrawer {
    constructor() {
      super();

      this.thumbnailGallery = this.querySelector('.thumbnails-list-container');
      this.mediaContainer = this.querySelector('.product-media-modal__content');
      this.debouncedScroll = debounce(this.handleMediaScroll.bind(this), 50);

      this.thumbnailGallery.querySelectorAll('.thumbnails-list__thumbnail').forEach((button, index) => {
        button.addEventListener('click', () => this.handleThumbnailClick(index));
      });

      this.mediaContainer.addEventListener('scroll', this.debouncedScroll);
    }

    handleMediaScroll() {
      const images = Array.from(this.mediaContainer.querySelectorAll('.product-media-modal__content__img'));
      const thumbnails = Array.from(this.thumbnailGallery.querySelectorAll('.thumbnails-list__thumbnail'));
      const containerRect = this.mediaContainer.getBoundingClientRect();

      let activeId = null;
      let closestDistance = Infinity;

      images.forEach((img) => {
        const rect = img.getBoundingClientRect();
        const distance = Math.abs(rect.top + rect.height / 2 - (containerRect.top + containerRect.height / 2));
        if (distance < closestDistance) {
          closestDistance = distance;
          activeId = img.dataset.mediaId;
        }
      });

      if (activeId) this.scrollToActiveThumbnail(activeId);
    }

    close() {
      super.close();
    }

    open(opener) {
      super.open(opener);
      this.showActiveMedia();
    }

    handleBodyClick(evt) {
      const target = evt.target;
      if (!target || !target.isConnected) return;

      const drawerElement = target.closest("side-drawer");
      const isInsideAnyDrawer = drawerElement !== null;
      const isOnToggle = target.closest("side-drawer-toggle") !== null;
      const isClickOnProductModalImage = target.closest(".product-media-modal__content img") !== null;
      const isInThumbnailsContainer = target.closest(".thumbnails-list-container") !== null;

      const isMobile = window.matchMedia("(max-width: 768px)").matches;

      if (isMobile && isClickOnProductModalImage) return;

      if (!isInThumbnailsContainer && (isClickOnProductModalImage || (!isInsideAnyDrawer && !isOnToggle))) {
        this.close();
      }
    }

    showActiveMedia() {
      const mediaId = this.openedBy?.getAttribute("data-media-id");
      if (!mediaId) return;

      this.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('active'));

      const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
      if (!activeMedia) return;

      activeMedia.classList.add('active');

      this.addEventListener('transitionend', function handler(e) {
        if (e.target === this) {
          activeMedia.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });

      this.scrollToActiveThumbnail(mediaId);

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
    }

    scrollToActiveThumbnail(mediaId) {
      const thumbnails = Array.from(this.thumbnailGallery.querySelectorAll('.thumbnails-list__thumbnail'));
      thumbnails.forEach(btn => btn.classList.remove('active'));
      thumbnails.forEach(btn => btn.removeAttribute('aria-current'));

      const activeThumb = thumbnails.find(
        (thumb) => thumb.getAttribute("data-media-id") === mediaId
      );

      if (activeThumb) {
        activeThumb.classList.add('active');
        activeThumb.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        activeThumb.setAttribute('aria-current', 'true');
      }
    }

    handleThumbnailClick(index) {
      const images = Array.from(this.mediaContainer.querySelectorAll('.product-media-modal__content__img'));
      const thumbnails = Array.from(this.thumbnailGallery.querySelectorAll('.thumbnails-list__thumbnail'));
      const targetImage = images[index];
      if (!targetImage) return;

      targetImage.scrollIntoView({
        behavior: "smooth",
        block: 'center',
      });

      images.forEach(img => img.classList.remove('active'));
      targetImage.classList.add('active');

      thumbnails.forEach(btn => btn.classList.remove('active'));
      thumbnails[index].classList.add('active');
    }
  });
}